export default __webpack_public_path__ + "assets/images/3611b5e860c92d392ef0b6c2079b1c09.svg";